module.exports = __webpack_public_path__ + "static/media/room2.9bfaeefa.png";